import React from 'react';
import PropTypes from 'prop-types';
import Edit from 'react-icons/lib/md/edit';
import Trash from 'react-icons/lib/fa/trash';
import { capitalize, chunk } from 'lodash';

const PhotoTable = (props) => {
  const photos = props.photos;
  const didInvalidate = props.didInvalidate;

  function photoCell(photo, key) {
    return (
      <div className='col-md-4' key={key}>
        <div className='host-photo-container'>
          <div className='host-photo'>
            <p style={{textAlign: 'center'}}>{photo.kind.split('_').map(s => capitalize(s)).join(' ')}</p>
            <img src={photo.image.small} className='img-polaroid' />
            {
              !photo.room_name &&
              <div className='photo-icons'>
                <a className='pull-left' href="#" onClick={(e) => props.editFunc(e, photo)}><Edit/></a>
                <a className='pull-left' href="#" onClick={(e) => props.destroyFunc(e, photo)}><Trash/></a>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  function loadingCell(key) {
    return (
      <div className='col-md-4' key={key}>
         <i className="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      </div>
    )
  }

  function photoRow(photoCells, i){
    return (
      <div className='row' key={i}>
        {photoCells.map(b => {return b} )}
      </div>
    )
  }

  function photoContainer(photos, loading=false) {
    let cells = photos.map((photo, i) => {return photoCell(photo, i)})
    if(loading) {
      cells.push(loadingCell(photos.length))
    }
    return (
      <div>
      {
        chunk(cells, 3).map((a, i) => {
          return photoRow(a, i)
        })
      }
      </div>
    )
  }

  return (
    <div className='container-fluid'>
      {photoContainer(photos, didInvalidate)}
    </div>
  )
};

PhotoTable.propTypes = {
  editFunc: PropTypes.func.isRequired,
  destroyFunc: PropTypes.func.isRequired,
  photos: PropTypes.array
};

export default PhotoTable;
